import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

export const RootStyled = styled(Box)(() => ({
  minHeight: '100vh',
  padding: 18,
  '@media (min-width: 900px)': {
    padding: 24,
  },
  '@media (min-width: 1200px)': {
    padding: 55,
  },
  '@media (min-width: 1536px)': {
    padding: 90,
  },
}));

export const HeaderModalStyled = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  '@media (max-width: 600px)': {
    '& svg': {
      fontSize: 32,
      marginLeft: -16,
    },
  },
  '& svg': {
    fontSize: 36,
    marginLeft: -16,
  },
}));

export const HeaderTitleStyled = styled(Typography)({
  margin: '18px 0 10px 0',
});

export const Subtitle = styled(Typography)({
  fontSize: '14px',
});

export const FormContainer = styled(Box)({
  border: '1px solid #707070',
  borderRadius: '8px',
  padding: 16,
  marginTop: 18,
});

export const FormTitle = styled(Typography)({
  margin: '20px 0',
});

export const FieldContainer = styled(Box)({
  margin: '15px 0',
  width: '90%',
});

export const ButtonContainer = styled(Box)({
  marginTop: '40px',
  marginBottom: '20px',
});

export const FormButton = styled(Button)({
  width: '10em',
  marginRight: '35px',
  padding: '8px',
});
